import { render } from "./ArticleTwoImages.vue?vue&type=template&id=7ece5570&scoped=true"
import script from "./ArticleTwoImages.vue?vue&type=script&lang=js"
export * from "./ArticleTwoImages.vue?vue&type=script&lang=js"

import "./ArticleTwoImages.vue?vue&type=style&index=0&id=7ece5570&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ece5570"]])

export default __exports__